import { $publicApi } from "@lending/lib/api";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";

function useGetInstitutionQuery() {
  const query = $publicApi.useSuspenseQuery(
    "get",
    "/v1/institution/",
    {},
    STANDARD_QUERY_CACHE_CONFIG
  );

  return {
    institution: query.data.institution,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { useGetInstitutionQuery };
